import React from 'react';
import { Button } from '@synergy-marine-group/synergy-ui';

const ButtonComponent = ({ name, handleClick, icon }) => {
  return (
    <Button className="max-w-none items-center" onClick={handleClick} size="large" variant="filled" rounded>
      <div className="flex csv-upload flex-row font-montserrat text-gray-500 uppercase text-sm items-center">
        {icon && <img className="mr-1" src={icon} alt="plus_icon" />}
        {name}
      </div>
    </Button>
  );
};

export default ButtonComponent;
